/**
 * @var isZipCode
 * @type {RegExp}
 * @access private
 * @desc Regular expression used to match Custom zip code.
 * best example would be the following 2:
 * 43206-2364 || 43206 - 2364 || 02680
 */
const isZipCode = /^[a-zA-Z0-9- ]{1,12}$/;

/**
 * @function isValidPostalCode
 * @desc Validates if the zip is a valid zip code
 *
 * @param {String} zip - postal code.
 * @returns {Boolean} is or isn't valid.
 */
const isValidPostalCode = (zip: string): boolean => {
  if (zip !== '') return isZipCode.test(zip);
  return false;
};

export default isValidPostalCode;
